import React, { useEffect, useCallback, useState} from 'react';
import GraphicalEnvelope from "components/instruments/envelope/GraphicalEnvelope.js";
import Colors from 'components/Colors.js';
import OperatorsMixer from "components/instruments/fm/OperatorsMixer.js";
import {PLANAR_SNAPSHOTS, OPERATORS_MIXER} from 'constants/pullable-types.js';
import PlaneSnapshots from "components/effects/plane/PlaneSnapshots.js";
import {connect} from 'react-redux';

const colors = new Colors();

const PullableInstrument = ({
    onDeleteEffect,
    sequencerEngine,
    instrumentPart
}) => { 
    let [oscillatorDetails, setOscillatorDetails] = useState(undefined);
    let [showWaveform, setShowWaveform] = useState(undefined);
    let {effect, instrument, track, type, subType} = instrumentPart;
    let inner = '';

    let header = (
        <div className="pulled-header">
          <div style={{backgroundColor: colors.getColorForTrack(track)}} className="effect-from">
            {track.envelopesTrack ?
             track.name :
             (track.trackNumber + 1) + '. ' + track.getName()}
          </div>
          <div onClick={onDeleteEffect} className="delete-button">
            -
          </div>
        </div>
    );
    
    let color = colors.getColorForTrack(track);
    if (type === OPERATORS_MIXER) {
        inner = (
            <OperatorsMixer
              isDraggable={false}
              setOscillatorDetails={setOscillatorDetails}
              oscillatorDetails={oscillatorDetails}
              showWaveform={showWaveform}
              setShowWaveform={setShowWaveform}
              color={color}
              sequencerEngine={sequencerEngine}
              instrument={instrument}/>
        );
    } else if (type === "SYNTH_ENVELOPE") {
        let envelope;
        let hasRelease = true;
        if (subType === "Amp") {
            envelope = instrument.ampEnvelope;
        } else if (subType === 'A') {
            envelope = instrument.oscillators[1].ampEnvelope;
        } else if (subType === 'B1') {
            envelope = instrument.oscillators[2].ampEnvelope;
        } else if (subType === 'B2') {
            envelope = instrument.oscillators[3].ampEnvelope;
        }
        inner  = (
            <GraphicalEnvelope
              instrument={instrument}
              width={200}
              fillColor={color}
              lineColor={color}
              sequencerEngine={sequencerEngine}
              envelope={envelope}
              name={subType}
              hasRelease={hasRelease}
              hasLevel={false}
            />);
    } else if (type === PLANAR_SNAPSHOTS) {
        inner = (
            <PlaneSnapshots effect={effect}/>
        );
    }

    return (
        <div className="pulled-instrument">
          {header}
          {inner}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PullableInstrument);
